import { createId } from '@paralleldrive/cuid2';
import { timestamp } from './utils/Time';

export interface ViewParameters {
  path: string;
  pathname?: string;
  query?: Record<string, any>;
  host?: string;
  name?: string;
}

export class View {
  viewId: string = createId();
  path: string;
  pathname?: string;
  query?: Record<string, any>;
  host?: string;
  name?: string;

  startedAt?: number;
  timeSpent?: number;

  constructor(params: ViewParameters) {
    this.pathname = params?.pathname;
    this.query = params?.query;
    this.path = params?.path;
    this.host = params?.host;
    this.name = params?.name;
    this.viewId = createId();
    this.startedAt = timestamp();
  }

  setRoute(params: ViewParameters) {
    this.pathname = params?.pathname;
    this.query = params?.query;
    this.path = params?.path;
    this.host = params?.host;
    this.name = params?.name;
  }

  end() {
    if (this.startedAt) {
      this.timeSpent = timestamp() - this.startedAt;
    }
  }
}
